export const english: string = "en";
export const dutch: string = "nl";
export const spanish: string = "es";
export const portuguese: string = "pt";
export const german: string = "de-DE";
export const austrian: string = "de-AT";
export const romanian: string = "ro";
export const norwegian: string = "nb";
export const danish: string = "da";
export const italian: string = "it";
export const hungarian: string = "hu";
export const greek: string = "gr";

export const allLanguages: string[] = [
  english,
  dutch,
  spanish,
  portuguese,
  german,
  austrian,
  romanian,
  norwegian,
  danish,
  italian,
  hungarian,
  greek,
];
